<div class="container-fluid wrapper-page">
  <div align="center" class="page-head">
    <h4 class="mt-2 mb-2">FRONT DESK PROFILE</h4>
  </div>
  <div>
    <h5><a href="javascript:void(0)"><i class="fa fa-arrow-circle-left" (click)="getback()"> BACK
        </i></a>
    </h5>
  </div>

  <div class="row">
    <div class="col-lg-12 col-12 col-md-12 col-sm-12">
      <div class="card m-b-30">
        <div class="card-body">
          <ul role="tablist">
            <li role="tab" *ngFor="let tab of frontDeskListofTab;let i=index">
              <a class="nav-link" (click)="forms[frontDeskCurrentTab].valid ? frontDeskAssignTab(tab.id) : false"
                [ngClass]="{'active':frontDeskListofTab == tab.id}" href="javascript:void(0)" role="tab"><span
                  class="number">{{i+1}}.</span>{{tab.title}}</a></li>
          </ul>

          <ng-container *ngFor="let tab of frontDeskListofTab">
            <section class="mt-35 ml-2 align-items-center text-center">
              <form [formGroup]="forms[tab.id]" *ngIf="frontDeskCurrentTab == tab.id && form_fields[tab.id]">
                <div class="row cust_row">
                  <div class="col-12 col-sm-12" *ngIf="frontDeskCurrentTab === 'additionalInformation'">
                    <div class="form-group">
                      <label class="col-lg-12 control-label "><strong>Additional Information:</strong>
                        Please specify any additional information.</label>
                    </div>
                  </div>

                  <div [ngClass]="field.class" *ngFor="let field of form_fields[tab.id]">
                    <sd-form-field [form]="forms[tab.id]" [applicationFormField]="field">
                    </sd-form-field>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12" *ngIf="frontDeskCurrentTab=='personalInformation'">
                    <app-drag-drop class="file-container" (fileSelected)="fileSelected($event)"
                      [supportedFormats]="'.png,.jpeg'" [multiple]="false"></app-drag-drop>
                  </div>
                </div>
              </form>
            </section>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-10"></div>
    <div class="col-2">
      <button type="button" class="btn btn-primary btn-doctor" *ngIf="frontDeskCurrentTab != 'personalInformation'"
        (click)="frontDeskPreviousTab()">Previous</button>
      <button type="button" class="btn btn-primary btn-doctor pull-right"
        [disabled]="forms[frontDeskCurrentTab].invalid" *ngIf="frontDeskCurrentTab != 'additionalInformation'"
        (click)="frontDeskNextTab()">Next</button>
      <button type="button" class="btn btn-primary btn-doctor pull-right"
        *ngIf="frontDeskCurrentTab == 'additionalInformation'" (click)="saveFrontDesk()">Save</button>
    </div>
  </div>

</div>